<template>
  <div>
    <p class="title">关联原订单：</p>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <form-text-box ref="searchForm"
      class="original-order"
      :column="3"
      :dataList="orderSearchConfig.list"
      :model="orderSearchConfig.model"
    />
  </div>
</template>

<script>
export default {
  props: ['orderSearchConfig'],
}
</script>
<style lang="scss" scoped>
.original-order {
  min-width: 1080px;
}
</style>
